<template>
    <div class="sound-control-wrapper">
        <span class="sound-control" @click="toggleSound" :class="{[classes]: classes}">
            <fa-icon class="volume-icon" icon="volume-up" v-if="!muted"></fa-icon>
            <fa-icon class="volume-icon muted" icon="volume-mute" v-if="muted"></fa-icon>
        </span>
        <input
            type="range"
            min="0"
            max="6"
            :value="volumeLevel"
            class="volume-slider"
            @input="onSlideVolume"
        />
    </div>
</template>

<script>
import throttle from 'lodash.throttle';

export default {
    props: ['classes'],
    name: 'Sound',
    computed: {
        muted() {
            return this.$store.state.appState.muted;
        },
        volumeLevel() {
            return this.$store.state.appState.volumeLevel;
        },
    },
    methods: {
        toggleSound() {
            this.$store.dispatch('setSoundReady');
            this.$store.dispatch('setMuted', !this.muted);

            const defaultVolume = this.muted ? 0 : 4;

            this.onSlideVolume({ target: { value: defaultVolume } });
        },
        onSlideVolume: throttle(function onSlideVolume(event) {
            const volumeLevel = parseInt(event.target.value, 10);
            this.$store.dispatch('setVolumeLevel', volumeLevel);
            let volume;

            switch (volumeLevel) {
                case 0:
                    volume = 0;
                    break;
                case 1:
                    volume = 0.05;
                    break;
                case 2:
                    volume = 0.15;
                    break;
                case 3:
                    volume = 0.30;
                    break;
                case 4:
                    volume = 0.45;
                    break;
                case 5:
                    volume = 0.6;
                    break;
                case 6:
                    volume = 0.75;
                    break;
                default:
                    volume = 0.45;
            }

            this.$store.dispatch('setVolume', volume);
        }, 100),
    },
};
</script>

<style scoped lang="scss">
    @use "@/styles/styles.scss" as *;

    .sound-control-wrapper {
        position: relative;
        min-height: 70px;

        .sound-control {
            font-size: 1.1em;
            cursor: pointer;

            .volume-icon {

                &.muted {
                    opacity: .75;
                    font-size: .95em;

                    &:hover {
                        opacity: 1;
                    }
                }
            }
        }

        .volume-slider {
            display: none;
            position: absolute;
            bottom: 15px;
            width: 35px;
            left: 50%;
            transform: translateX(-50%);
            -webkit-appearance: none;
            appearance: none;
            height: 6px;
            background: $off-white;
            outline: none;
            -webkit-transition: .2s;
            transition: opacity .2s;
            border-radius: 6px;
            box-shadow: 1px 1px 2px 1px $medium-gray;
        }

        .volume-slider::-webkit-slider-thumb {
            -webkit-appearance: none;
            appearance: none;
            width: 13px;
            height: 13px;
            background: $berserker;
            cursor: pointer;
            border-radius: 50%;
        }

        .volume-slider::-moz-range-thumb {
            width: 13px;
            height: 13px;
            background: $berserker;
            cursor: pointer;
            border-radius: 50%;
        }

        &:hover {

            .volume-slider {
                display: block;
            }
        }
    }

    .game-container {

        .sound-control {
            opacity: .75;

            &.btn {
                padding: 6px 8px;
            }

            &:hover {
                opacity: 1;
            }

            .volume-icon {
                min-width: 18.5px;

                &.muted {
                    opacity: 1;
                }
            }
        }

        .mobile-game-menu  {

            .sound-control-wrapper {
                min-height: auto;

                .sound-control {
                    opacity: 1;
                }

                .volume-slider {
                    top: -175%;
                    left: -10px;
                    transform: rotate(-90deg);
                }
            }
        }

        .waiting-room {

            .controls-group {

                .sound-control-position {
                    display: inline-block;
                    position: relative;
                    right: auto;
                    top: auto;
                }
            }

            .sound-control-wrapper {
                margin-left: -2px;
                min-height: auto;
                min-width: 45px;
                text-align: right;

                .sound-control {
                    opacity: 1;

                    .volume-icon {
                        opacity: 1;

                        &.muted {
                            opacity: .75;
                        }

                        &:hover {

                            &.muted {
                                opacity: 1;
                            }
                        }
                    }
                }

                .volume-slider {
                    left: 0;
                    top: 5px;
                    width: 25px;
                    bottom: auto;
                    transform: rotate(-90deg);
                }

                .volume-slider::-webkit-slider-thumb {
                    width: 10px;
                    height: 10px;
                }

                .volume-slider::-moz-range-thumb {
                    width: 10px;
                    height: 10px;
                }
            }
        }
    }

    .mobile-game-menu {

        .sound-control-wrapper {

            .sound-control {

                .volume-icon {

                    &.muted {
                        font-size: 1.1em;
                    }
                }
            }
        }
    }

</style>
